import $ from 'jquery';

import Vars from '../../vars'

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

import DropzoneFloor from "../dropzone/floor";
import Dropzone from "../classes/Dropzone";

class Floor {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init();
    }

    _elems = {
        $modal : $(),
        $form  : $()
    };

    _const = {
        entities : 'floors',
        entity   : 'floor',
        title : {
            add  : '',
            edit : ''
        },
        parent : {
            entities : 'sections',
            entity   : 'section',
            parent   : {
                entities : 'buildings',
                entity   : 'building',
                parent   : {
                    entities : 'objects',
                    entity   : 'object',
                }
            }
        }
    };
    
    _state = {
        item    : {},
        items   : {},
        section : {},
        dropzone: {
            items : {}
        }
    };

    _args = {
        item     : {},
        section  : {},
        building : {},
        object   : {},
        progress : {}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.chess    = args.chess;
        self._args.building = args.building || self._args.building;
        self._args.object   = Object.keys(self._args.building).length && self._args.building.object ? self._args.building.object : self._args.object;
        self._args.progress = args.progress;

        self._args.mode    = args.mode;
    };

    _setDropzone = (type) => {
        let self = this;

        self._state.dropzone.items[type] = DropzoneFloor.get({
            item     : self._state.item,
            items    : self._state.items,
            parent1  : self._args.object,
            parent2  : self._args.building,
            parent3  : self._state.section,
            entities : self._const.entities,
            chess    : self._args.chess,
            progress : self._state.progress,
            mode     : type
        });
        self._state.dropzone.entity = self._state.item;
    };

    _initModal = () => {
        let self = this;

        self._state.item    = {};
        self._state.items   = self._args.chess._getSelectedFloors();
        self._state.section = self._args.chess._getSectionById(self._state.items[0].id);

        const floorsHaveTheSameFlatComposition = self._state.items[0].floors.map(function (selected_floor) {
            let selected_floor_flats = self._state.section.flats.filter(function (flat) {
                return flat.floor_id == selected_floor.id;
            });

            let flat_composition = Array(self._state.section.count_of_columns).join('.').split('.').map(function (nothing, column_index) {
                let flat_on_that_position = null;

                selected_floor_flats.some(function (selected_floor_flat) {
                    if (selected_floor_flat.column_index != column_index)
                        return false;
                    flat_on_that_position = selected_floor_flat;
                    return true;
                });
                return flat_on_that_position;
            }).reduce(function (flat_composition, column_flat, column_index, column_flats) {
                if (!flat_composition.length) {
                    flat_composition.push(1);
                    return flat_composition;
                }
                if (column_flat && column_flat.group && column_flats[column_index - 1] && column_flats[column_index - 1].group) {
                    if (column_flat.group.id == column_flats[column_index - 1].group.id) {
                        ++flat_composition[flat_composition.length - 1];
                        return flat_composition;
                    }
                }
                flat_composition.push(1);
                return flat_composition;
            }, []);
            return flat_composition;
        }).every(function (flat_composition, flat_composition_index, flat_compositions) {
            if (flat_composition_index == 0)
                return true;
            return flat_composition.join('.') == flat_compositions[flat_composition_index - 1].join('.');
        });

        self._state.items[0].floors.forEach(function (selected_floor) {
            let floor = self._args.chess.getFloorBySectionAndId(self._state.section, selected_floor.id);

            Object.keys(floor).forEach(function (property_name) {
                if (['id', 'index'].indexOf(property_name) > -1)
                    return;
                if (property_name == 'plans') {
                    if (self._state.item.plans === null) return;
                    if (self._state.item.plans === undefined && floor.plans) {
                        self._state.item.plans = floor.plans;
                        return;
                    }
                    let common_floor_plan_string = self._state.item.plans.map(function (plan) {
                        return plan.id;
                    }).join('-');
                    let floor_plan_string = floor.plans.map(function (plan) {
                        return plan.id;
                    }).join('-');
                    if (common_floor_plan_string !== floor_plan_string) {
                        self._state.item.plans = null;
                        return;
                    }
                    return;
                }
                if (property_name == 'parking_plans') {
                    if (self._state.item.parking_plans === null) return;
                    if (self._state.item.parking_plans === undefined && floor.parking_plans) {
                        self._state.item.parking_plans = floor.parking_plans;
                        return;
                    }
                    let common_floor_parking_plan_string = self._state.item.parking_plans.map(function (parking_plan) {
                        return parking_plan.id;
                    }).join('-');
                    let floor_parking_plan_string = floor.parking_plans.map(function (parking_plan) {
                        return parking_plan.id;
                    }).join('-');
                    if (common_floor_parking_plan_string !== floor_parking_plan_string) {
                        self._state.item.parking_plans = null;
                        return;
                    }
                    return;
                }
                if (self._state.item[property_name] === undefined) {
                    self._state.item[property_name] = floor[property_name];
                    return;
                }
                if (self._state.item[property_name] !== floor[property_name]) {
                    self._state.item[property_name] = null;
                    return;
                }
            });
        });

        let has_ground_floors = self._state.items[0].floors.some(function (selected_floor) {
            let floor = self._args.chess.getFloorBySectionAndId(self._state.section, selected_floor.id);
            return floor.number <= 0;
        });

        let has_flats = self._state.items[0].floors.some(function (selected_floor) {
            let floor = self._args.chess.getFloorBySectionAndId(self._state.section, selected_floor.id);
            return self._state.section.flats.some(function (flat) {
                return flat.floor_id == floor.id;
            });
        });

        self._elems.$modal = new Modal({
            title: 'Редактирование этажей',
            content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                common_floor       : self._state.item,
                allow_plan_editing : floorsHaveTheSameFlatComposition ? true : false,
                selected_floors    : self._state.items,
                has_ground_floors  : has_ground_floors,
                has_flats          : has_flats
            }),
            closingConfirmation    : true,
            dropzone               : self._state.dropzone
        });

        self._elems.$form = self._elems.$modal.find('#' + self._const.entity + '-form');

        let $dropzone = self._elems.$form.find('.dropzone');

        if (floorsHaveTheSameFlatComposition && self._state.item.type) {
            if (self._state.item.plans) {
                self._setDropzone('plans');

                if ($dropzone.length) {
                    if (Object.keys(self._state.dropzone).length && self._state.dropzone.items) {
                        $dropzone.each(function(){
                            let dropzoneControl = $(this)[0].dropzone;
                            if (dropzoneControl) dropzoneControl.destroy();
                            new Dropzone({
                                root   : $(this),
                                form   : self._elems.$form,
                                items  : self._state.dropzone.items,
                                entity : self._const.entity
                            })
                        });
                    }
                }
            }
            else {
                self._elems.$form.find('.form-field[data-name="plan_ids"] .dropzone .dz-unblock').click(function (e) {
                    e.preventDefault();
                    self._elems.$form.find('.form-field[data-name="plan_ids"] .dropzone .dz-default.dz-message').remove();
                    self._elems.$form.find('input[name="floor[with_plans]"]').prop('disabled', false);
                    self._state.item.plans = [];
                    self._setDropzone('plans');

                    if ($dropzone.length) {
                        if (Object.keys(self._state.dropzone).length && self._state.dropzone.items) {
                            $dropzone.each(function(){
                                let dropzoneControl = $(this)[0].dropzone;
                                if (dropzoneControl) dropzoneControl.destroy();
                                new Dropzone({
                                    root   : $(this),
                                    form   : self._elems.$form,
                                    items  : self._state.dropzone.items,
                                    entity : self._const.entity
                                })
                            });
                        }
                    }

                    return false;
                });
            }
        }

        if (self._state.item.type) {
            if (self._state.item.parking_plans) {
                self._setDropzone('parking_plans');
                if ($dropzone.length) {
                    if (Object.keys(self._state.dropzone).length && self._state.dropzone.items) {
                        $dropzone.each(function(){
                            let dropzoneControl = $(this)[0].dropzone;
                            if (dropzoneControl) dropzoneControl.destroy();
                            new Dropzone({
                                root   : $(this),
                                form   : self._elems.$form,
                                items  : self._state.dropzone.items,
                                entity : self._const.entity
                            })
                        });
                    }
                }
            }
            else {
                self._elems.$form.find('.form-field[data-name="parking_plan_ids"] .dropzone .dz-unblock').click(function (e) {
                    e.preventDefault();
                    self._elems.$form.find('.form-field[data-name="parking_plan_ids"] .dropzone .dz-default.dz-message').remove();
                    self._elems.$form.find('input[name="floor[with_parking_plans]"]').prop('disabled', false);
                    self._state.item.parking_plans = [];
                    self._setDropzone('parking_plans');
                    if ($dropzone.length) {
                        if (Object.keys(self._state.dropzone).length && self._state.dropzone.items) {
                            $dropzone.each(function(){
                                let dropzoneControl = $(this)[0].dropzone;
                                if (dropzoneControl) dropzoneControl.destroy();
                                new Dropzone({
                                    root   : $(this),
                                    form   : self._elems.$form,
                                    items  : self._state.dropzone.items,
                                    entity : self._const.entity
                                })
                            });
                        }
                    }
                    return false;
                });
            }
        }

        self._elems.$form.find('.form-field[data-name="type"] .select select').change(function () {
            if ($(this).val() == 'technical') {
                self._elems.$form.find('.form-field[data-name="has_no_flats"]').hide();
                self._elems.$form.find('.form-field[data-name="plan_ids"]').hide();
                self._elems.$form.find('.form-field[data-name="parking_plan_ids"]').hide();
            }
            else {
                self._elems.$form.find('.form-field[data-name="has_no_flats"]').show();
                self._elems.$form.find('.form-field[data-name="parking_plan_ids"]').show();

                if (self._elems.$form.find('.form-field[data-name="has_no_flats"] .checkbox').hasClass('checked')) {
                    self._elems.$form.find('.form-field[data-name="plan_ids"]').hide();
                }
                else {
                    self._elems.$form.find('.form-field[data-name="plan_ids"]').show();
                }
            }
        });

        self._elems.$form.find('.form-field[data-name="has_no_flats"] .checkbox').on('check', function () {
            self._elems.$form.find('.form-field[data-name="plan_ids"]').hide();
        }).on('uncheck', function () {
            self._elems.$form.find('.form-field[data-name="plan_ids"]').show();
        });

        self._elems.$form.submit(function (e) {
            e.preventDefault();
            loader.increase();

            return Request.send({
                path: '/api/objects/' + self._args.object.id + '/buildings/' + self._args.building.id + '/sections/' + self._state.section.id + '/' + self._const.entities + '/edit',
                method: 'POST',
                data: self._elems.$form.serialize().split('&').filter(function (parameter) {
                    return parameter[parameter.length - 1] != '=';
                }).join('&') + '&' + $.param({
                    floor_ids : self._state.items[0].floors.map(function (floor) {
                        return floor.id;
                    })
                }),
                done: function (response) {
                    loader.decrease();

                    if (response.error) {
                        // self.profile.callback.error(response.error, self._elems.$form);
                        return;
                    }

                    let floors = response.floors;
                    let flats  = response.flats;

                    self._args.chess._args.building.sections.filter(function(section){
                        return self._state.section.id == section.id;
                    }).pop().floors = floors;
                    self._args.chess._args.building.sections.filter(function(section){
                        return self._state.section.id == section.id;
                    }).pop().flats = flats;

                    self._args.chess._unselectAll();
                    self._args.chess._updateSections();
                    self._args.chess._updateStickySections();
                    self._args.chess._updateCurrentSection();
                    self._args.chess._args.buildingSelf._bindActions();

                    self._args.progress.update({
                        object : self._args.object
                    })
                }
            });
        });
    };

    _building = () => {
        let self = this;

        if (!self._args.chess._getSelectedFloors().length) {
            new Modal({
                title: 'Информация',
                content: Utils.renderProfileTemplate('info', {
                    message : 'Пожалуйста, выделите хотя бы один этаж. Чтобы выделить этаж, достаточно нажать на него один раз либо выделить любую ячейку этого этажа.',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Закрыть'
                        },
                        two : null
                    }
                })
            });
            return;
        }

        if (self._args.chess._getSelectedFloors().length > 1) {
            new Modal({
                title: 'Информация',
                content: Utils.renderProfileTemplate('info', {
                    message : 'Редактировать этажи можно только у одной секции в один момент времени. Пожалуйста, оставьте выделение этажей только у необходимой секции.',
                    buttons : {
                        one : {
                            class : 'confirm button--edit',
                            title : 'Закрыть'
                        },
                        two : null
                    }
                })
            });
        }

        self._initModal();
    };

    _init = () => {
        let self = this;

        if (self._args.mode === Vars.view.building) {
            self._building();
        }
    }
}

export default Floor;